<!-- 既存の入力内容を表示するやつ -->
<template>
  <div class="karadaKarte">
    <!-- ユーザー情報 -->
    <div class="karadaKarte--content">
      <heading :title="$t('yourInformation.yourInformation')" class="heading" />
      <DisplayConfirmation
        v-for="(userInfo, index) in userInfo"
        :key="`first-${index}`"
        :index="index"
        :label="$t(`yourInformation.${userInfo.label}`)"
        :value="userInfo.value"
        :unit="userInfo.unit"
        :gender="userInfo.gender"
        :dataTest="userInfo.label"
      />
    </div>

    <!-- 身体情報 -->
    <div class="karadaKarte--content">
      <heading
        :title="$t('yourPhysicalInformation.yourPhysicalInformation')"
        class="heading"
      />
      <DisplayConfirmation
        v-for="(physicalInfo, index) in physicalInfo"
        :key="`second-${index}`"
        :index="index"
        :label="$t(`yourPhysicalInformation.${physicalInfo.label}`)"
        :value="physicalInfo.value"
        :unit="physicalInfo.unit"
        :condition="physicalInfo.condition"
        :whetherAbnormalTest="physicalInfo.whetherAbnormalTest"
        :dataTest="physicalInfo.label"
      />
    </div>

    <!-- 病歴 -->
    <div class="karadaKarte--content">
      <heading :title="$t('yourPhysicalInformation.yourMedicalHistory')" />
      <display-confirmation
        v-for="(medicalHistory, index) in medicalHistory"
        :key="`third-${index}`"
        :index="index"
        :label="$t(`diseases.${medicalHistory.label}`)"
        :value="medicalHistory.value"
        :diseaseHistory="medicalHistory.diseaseHistory"
        :dataTest="`your-${medicalHistory.label}`"
      />
    </div>

    <!-- 家族の病歴 -->
    <div class="karadaKarte--content">
      <heading
        :title="$t('yourFamilysMedicalHistory.yourFamilysMedicalHistory')"
        class="heading"
      />
      <display-confirmation
        v-for="(familyMedicalHistory, index) in familysMedicalHistory"
        :key="`forth-${index}`"
        :index="index"
        :label="$t(`diseases.${familyMedicalHistory.label}`)"
        :value="familyMedicalHistory.value"
        :diseaseHistory="familyMedicalHistory.diseaseHistory"
        :dataTest="`family-${familyMedicalHistory.label}`"
      />
    </div>

    <!-- 血液検査 -->
    <div class="karadaKarte--content">
      <heading :title="$t('bloodTestResult.yourBloodTest')" class="heading" />
      <display-confirmation
        v-for="(bloodTestResult, index) in bloodTestResult"
        :key="`fifth-${index}`"
        :index="index"
        :label="$t(`bloodTestResult.${bloodTestResult.label}`)"
        :value="bloodTestResult.value"
        :unit="bloodTestResult.unit"
        :dataTest="bloodTestResult.label"
      />
    </div>

    <!-- 尿検査 -->
    <div class="karadaKarte--content">
      <heading
        :title="$t('bloodTestResult.yoururinaryTestResult')"
        class="heading"
      />
      <display-confirmation
        v-for="(urinaryTestResult, index) in urinaryTestResult"
        :key="`seventhh-${index}`"
        :index="index"
        :label="$t(`bloodTestResult.${urinaryTestResult.label}`)"
        :value="urinaryTestResult.value"
        :urinaryTest="urinaryTestResult.urinaryTest"
        :urinarySugar="urinaryTestResult.urinarySugar"
        :unit="urinaryTestResult.unit"
        :dataTest="urinaryTestResult.label"
      />
    </div>

    <!-- 生活習慣 -->
    <div class="karadaKarte--content">
      <heading :title="$t('yourLifestyle.yourLifestyle')" class="heading" />
      <display-confirmation
        v-for="(yourLifestyle, index) in yourLifestyle"
        :key="`sixth-${index}`"
        :index="index"
        :label="$t(`yourLifestyle.${yourLifestyle.label}`)"
        :value="yourLifestyle.value"
        :unit="yourLifestyle.unit"
        :smokingHabit="yourLifestyle.smokingHabit"
        :dataTest="yourLifestyle.label"
      />
    </div>
  </div>
</template>

<script>
import Heading from "@/components/atoms/Heading.vue";
import DisplayConfirmation from "@/components/molecules/AiDiseasePrediction/DisplayConfirmation.vue";

export default {
  components: {
    Heading,
    DisplayConfirmation,
  },
  data() {
    return {
      date: "",
      features: {},
    };
  },
  computed: {
    userInfo() {
      return [
        {
          label: "gender",
          value: this.features.GENERAL.SEX,
          gender: true,
        },
        {
          label: "age",
          value: this.features.GENERAL.AGE,
          unit: this.$i18n.t("yourLifestyle.yearsOld"),
        },
      ];
    },
    physicalInfo() {
      return [
        {
          label: "healthExamDate",
          value: this.features.GENERAL.T,
        },
        {
          label: "condition",
          value: this.features.GENERAL.DFAB_PTN_CD,
          condition: true,
        },
        {
          label: "waistCircumference",
          value: this.features.MEASURE.WAIST,
          unit: "cm",
        },
        {
          label: "BMI",
          value: this.features.MEASURE.BMI,
        },
        {
          label: "sbp",
          value: this.features.BLOOD_PRESSURE.BP_HIGH,
        },
        {
          label: "dbp",
          value: this.features.BLOOD_PRESSURE.BP_LWST,
        },
        // 新規追加項目
        {
          label: "Weight",
          value: this.features.MEASURE.WEIGHT,
          unit: "kg",
        },
        {
          label: "Electrocardiography",
          value: this.features.MEASURE.ELECTROCARDIOGRAPHY,
          whetherAbnormalTest: true,
        },
        {
          label: "SputumExamination",
          value: this.features.MEASURE.SPUTUM_EXAMINATION,
          whetherAbnormalTest: true,
        },
        // 聴力 1000Hz
        {
          label: "HearingLabel1000HzLeft",
          value: this.features.MEASURE.HEARING_LOW_LEFT,
          whetherAbnormalTest: true,
        },
        {
          label: "HearingLabel1000HzRight",
          value: this.features.MEASURE.HEARING_LOW_RIGHT,
          whetherAbnormalTest: true,
        },
        // 聴力 4000Hz
        {
          label: "HearingLabel4000HzLeft",
          value: this.features.MEASURE.HEARING_HIGH_LEFT,
          whetherAbnormalTest: true,
        },
        {
          label: "HearingLabel4000HzRight",
          value: this.features.MEASURE.HEARING_HIGH_RIGHT,
          whetherAbnormalTest: true,
        },
        // 視力 裸眼
        {
          label: "UncorrectedEyeSightLeft",
          value: this.features.MEASURE.WITHOUT_GLASSES_LEFT,
        },
        {
          label: "UncorrectedEyeSightRight",
          value: this.features.MEASURE.WITHOUT_GLASSES_RIGHT,
        },
        // 視力　矯正
        {
          label: "CorrectedEyeSightLeft",
          value: this.features.MEASURE.WITH_GLASSES_LEFT,
        },
        {
          label: "CorrectedEyeSightRight",
          value: this.features.MEASURE.WITH_GLASSES_RIGHT,
        },
      ];
    },
    medicalHistory() {
      return [
        {
          label: "stroke",
          value: this.features.PAST_HISTORY.HCHK_APOP_PMH_YN,
          diseaseHistory: true,
        },
        {
          label: "diabetes",
          value: this.features.PAST_HISTORY.HCHK_DIABML_PMH_YN,
          diseaseHistory: true,
        },
        {
          label: "cancerOrOther",
          value: this.features.PAST_HISTORY.HCHK_ETCDSE_PMH_YN,
          diseaseHistory: true,
        },
        {
          label: "heartDisease",
          value: this.features.PAST_HISTORY.HCHK_HDISE_PMH_YN,
          diseaseHistory: true,
        },
        {
          label: "highBloodPressure",
          value: this.features.PAST_HISTORY.HCHK_HPLPDM_PMH_YN,
          diseaseHistory: true,
        },
        {
          label: "hyperlipemia",
          value: this.features.PAST_HISTORY.HCHK_HPRTS_PMH_YN,
          diseaseHistory: true,
        },
        {
          label: "tuberculosis",
          value: this.features.PAST_HISTORY.HCHK_PHSS_PMH_YN,
          diseaseHistory: true,
        },
      ];
    },
    familysMedicalHistory() {
      return [
        {
          label: "stroke",
          value: this.features.FAMILY_HISTORY.FMLY_APOP_PATIEN_YN,
          diseaseHistory: true,
        },
        {
          label: "diabetes",
          value: this.features.FAMILY_HISTORY.FMLY_DIABML_PATIEN_YN,
          diseaseHistory: true,
        },
        {
          label: "cancerOrOther",
          value: this.features.FAMILY_HISTORY.FMLY_CANCER_PATIEN_YN,
          diseaseHistory: true,
        },
        {
          label: "heartDisease",
          value: this.features.FAMILY_HISTORY.FMLY_HDISE_PATIEN_YN,
          diseaseHistory: true,
        },
        {
          label: "highBloodPressure",
          value: this.features.FAMILY_HISTORY.FMLY_HPRTS_PATIEN_YN,
          diseaseHistory: true,
        },
      ];
    },
    bloodTestResult() {
      return [
        {
          label: "fastingBloodSugarLevel",
          value: this.features.BLOOD_TEST.BLDS,
          unit: "mg/dL",
        },
        // HbA1c
        {
          label: "HbA1c",
          value: this.features.BLOOD_TEST.HBA1C,
          unit: "%",
        },
        {
          label: "totalCholesterol",
          value: this.features.BLOOD_TEST.TOT_CHOLE,
          unit: "mg/dL",
        },
        {
          label: "triglyceride",
          value: this.features.BLOOD_TEST.TRIGLYCERIDE,
          unit: "mg/dL",
        },
        {
          label: "hdlcholesterol",
          value: this.features.BLOOD_TEST.HDL_CHOLE,
          unit: "mg/dL",
        },
        {
          label: "ldlCholesterol",
          value: this.features.BLOOD_TEST.LDL_CHOLE,
          unit: "mg/dL",
        },
        {
          label: "hemoglobin",
          value: this.features.BLOOD_TEST.HMG,
          unit: "g/dL",
        },
        // 新規項目追加
        {
          label: "whiteBloodCells",
          value: this.features.BLOOD_TEST.WHITE_BLC,
          unit: "/μL",
        },
        {
          label: "redBloodCells",
          value: this.features.BLOOD_TEST.RED_BLC,
          unit: "10^4/μL",
        },
        {
          label: "plateletCount",
          value: this.features.BLOOD_TEST.PLT_CNT,
          unit: "10^4/μL",
        },
        {
          label: "hematocrit",
          value: this.features.BLOOD_TEST.HEMATOCRIT,
          unit: "％",
        },
        //
        {
          label: "γGtp",
          value: this.features.BLOOD_TEST.GAMMA_GTP,
          unit: "U/L",
        },
        {
          label: "AST",
          value: this.features.BLOOD_TEST.SGOT_AST,
          unit: "U/L",
        },
        {
          label: "ALT",
          value: this.features.BLOOD_TEST.SGPT_ALT,
          unit: "U/L",
        },
      ];
    },
    urinaryTestResult() {
      return [
        {
          label: "urinaryProtein",
          value: this.features.URINE_TEST.OLIG_PROTE_CD,
          urinaryTest: true,
        },
        {
          label: "serumCreatinine",
          value: this.features.BLOOD_TEST.CREATININE,
          unit: "mg/DL",
        },
        // 尿酸
        {
          label: "urinaryAcid",
          value: this.features.URINE_TEST.URIC_ACID,
          unit: "mg/dL",
        },
        // 尿糖
        {
          label: "urinarySugar",
          value: this.features.URINE_TEST.URIC_SUGAR,
          urinarySugar: true,
        },
      ];
    },
    yourLifestyle() {
      return [
        // 喫煙習慣
        {
          label: "smokingHabit",
          value: this.features.SMOKE.SMK_STAT_TYPE_RSPS_CD,
          smokingHabit: true,
        },
        // 禁煙以前の1日の平均喫煙数
        {
          label: "averageSmokingAmountInADayBefore",
          value: this.features.SMOKE.PAST_DSQTY_RSPS_CD,
          unit: this.$i18n.t("yourLifestyle.ea/day"),
        },
        // 禁煙以前の喫煙期間
        {
          label: "smokingPeriodBeforeStopSmoking",
          value: this.features.SMOKE.PAST_SMK_TERM_RSPS_CD,
          unit: this.$i18n.t("yourLifestyle.year(s)"),
        },
        // 1日の平均喫煙量
        {
          label: "averageSmokingAmountInADay",
          value: this.features.SMOKE.CUR_DSQTY_RSPS_CD,
          unit: this.$i18n.t("yourLifestyle.ea/day"),
        },
        // 喫煙期間
        {
          label: "smokingPeriod",
          value: this.features.SMOKE.CUR_SMK_TERM_RSPS_CD,
          unit: this.$i18n.t("yourLifestyle.year(s)"),
        },
        // 1週間の平均飲酒日数
        {
          label: "averageNumberOfDrinkingDaysInAWeek",
          value: this.features.DRINK.DRNK_HABIT_RSPS_CD,
          unit: this.$i18n.t("yourLifestyle.day(s)"),
        },
        // 1日の飲酒量 yourLifestyle.cup(s)
        {
          label: "drinkingAmountInADay",
          value: this.features.DRINK.TM1_DRKQTY_RSPS_CD,
          unit: this.$i18n.t("yourLifestyle.cup(s)"),
        },
        // 1週間の平均飲酒量
        {
          label: "averageNumberOfAmountInAWeek",
          value: this.features.DRINK.DRNK_QTY_WEK_CD,
          unit: this.$i18n.t("yourLifestyle.cup(s)"),
        },
        {
          label: "numberOfHigh-intensityExerciseDays",
          value: this.features.EXERCISE.MOV20_WEK_FREQ_ID,
          unit: this.$i18n.t("yourLifestyle.day(s)"),
        },
        {
          label: "numberOfMid-intensityExerciseDays",
          value: this.features.EXERCISE.MOV30_WEK_FREQ_ID,
          unit: this.$i18n.t("yourLifestyle.day(s)"),
        },
        {
          label: "numberOfLightExerciseDays",
          value: this.features.EXERCISE.WLK30_WEK_FREQ_ID,
          unit: this.$i18n.t("yourLifestyle.day(s)"),
        },
      ];
    },
  },
  created() {
    this.date = this.$route.params.date;
    this.$store.dispatch("karte/setDiagnosisDate", {
      date: this.date,
    });
    this.features = this.$store.getters[`karte/getFeaturesByDate`];
  },
};
</script>

<style scoped>
.karadaKarte {
  width: 60%;
  margin-top: 80px;
}
</style>
